var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"up-btn"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.handleClick}},[_vm._v("\n    批量导入\n  ")]),_vm._v(" "),_c('input',{ref:"filElem",staticClass:"upload-file",attrs:{"type":"file","accept":"image/png, image/jpeg, image/jpg, video/mp4","multiple":""},on:{"change":_vm.handleChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9aab90c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadButton.vue
// module id = null
// module chunks = 